/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ridge_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each column becomes one ridge; rows are stacked top to bottom.`)
};

const es_ridge_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada columna se convierte en una cresta; las filas se apilan de arriba hacia abajo.`)
};

const de_ridge_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jede Spalte wird zu einem Grat; Reihen werden von oben nach unten gestapelt.`)
};

const nl_ridge_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elke kolom wordt één richel; rijen worden van boven naar beneden gestapeld.`)
};

const fr_ridge_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaque colonne devient une crête ; les lignes sont empilées de haut en bas.`)
};

const it_ridge_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ogni colonna diventa un ridge; le righe sono impilate dall'alto verso il basso.`)
};

const pt_br2_ridge_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada coluna vira uma crista; as linhas são empilhadas de cima para baixo.`)
};

const pt_ridge_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada coluna torna-se uma crista; as linhas são empilhadas de cima para baixo.`)
};

const ja_ridge_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各列が1つのリッジになり、行は上から下へ積み重ねられます。`)
};

const zh_ridge_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每一列变成一条山脊；各行从上到下层叠排列。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ridge_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ridge_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ridge_ex1", locale)
	if (locale === "en") return en_ridge_ex1(inputs)
	if (locale === "es") return es_ridge_ex1(inputs)
	if (locale === "de") return de_ridge_ex1(inputs)
	if (locale === "nl") return nl_ridge_ex1(inputs)
	if (locale === "fr") return fr_ridge_ex1(inputs)
	if (locale === "it") return it_ridge_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_ridge_ex1(inputs)
	if (locale === "pt") return pt_ridge_ex1(inputs)
	if (locale === "ja") return ja_ridge_ex1(inputs)
	return zh_ridge_ex1(inputs)
};